<template>

    <b-container class="container">

		<router-link class="admin-link" :to="{ path: `/Admin/Activities`, query: { 'api-Version': apiHeaders['api-Version'] } }">
			&larr; Перейти к списку типов активностей
		</router-link>

		<div class="admin-title">{{header}}</div>

		<b-tabs>

			<b-tab active title="Основная информация">

				<b-container v-if="load.Loading" class="container-tab-spinner">
					<spinner/>
				</b-container>
				<b-container v-else class="p-0">

					<b-row class="m-15-0">
						<label for="nameActivity">Название*</label>
						<b-form-input id="nameActivity" 
									v-model="entity.Name"
									placeholder="Введите название активности" />
					</b-row>

					<b-row class="m-0">
						<label for="statusActivity">Статус*</label>
						<custom-multiselect id="statusActivity"
											class="mb-13" 
											v-model="entity.Status"
											:options="auditStatus"/>
					</b-row>

					<b-row class="m-0">
						<b-col cols="5">
							<label for="typeActivity">Тип аудита*</label>
							<custom-multiselect id="typeActivity" 
												class="mb-13" 
												v-model="entity.AuditType"
												:options="auditTypes"/>
						</b-col>
						<b-col cols="4">
							<label for="isNeedCheck">Проверка геолокации</label>
							<yes-no-input id="isNeedCheck"
										v-model="entity.IsNeedCheck" />
						</b-col>
						
					</b-row>

					<b-row class="m-0">
						<label for="tagsActivity">Теги активности</label>
						<custom-color-multiselect id="tagsActivity" 
												class="mb-13" 
												v-model="entity.TagIds"
												:options="allTags"
												:multiple="true"
												:tag-color = "true"
												placeholder="Выберите теги"/>
					</b-row>

				</b-container>

			</b-tab>

			<b-tab title="Блоки вопросов">

				<b-container v-if="load.Loading" class="container-tab-spinner">
					<spinner/>
				</b-container>
				<b-container v-else class="p-0">

					<draggable v-model="entity.BlockIds" v-bind="{handle:'.handle', animation:150}">

						<b-container v-for="(item, index) in entity.BlockIds"
									 class="m-0 p-0"
									 :key="index">

							<b-row class="m-13-0">

								<b-col class="pl-0">
									<custom-multiselect required
														v-model="entity.BlockIds[index]"
														:options="allBlocksNoReplay"/>
								</b-col>

								<b-col cols="2" class="p-0-5">  																
									<b-button block
											  :disabled="item == null"
											  @click="openBlock(item)"
											  class="draggable-button green">
										Открыть
									</b-button>
								</b-col>

								<b-col cols="2">  																
									<b-button block
											  @click="deleteBlock(index)"
											  class="draggable-button red">
										Удалить
									</b-button>
								</b-col>

								<b-col cols="1" class="sort-handle handle" />

							</b-row>
						</b-container>	

					</draggable>

					<b-row class="m-20-0">
						<b-col cols="3" class="p-0"> 
							<b-button block 
									class="draggable-button green" 
									@click="addBlock" >
								Добавить блок вопросов
							</b-button>
						</b-col>
					</b-row>

				</b-container>

			</b-tab>
		</b-tabs>

		<hr v-if="!load.Loading" class="my-4">

		<b-row v-if="!load.Loading" class="m-0">

			<b-col cols="2" class="p-0 mr-10">
				<b-button block 
                          id="admin-btn-save"
                          class="admin-button"
                          @click="saveActivity">
                    Сохранить
                </b-button>
			</b-col>

			<b-col cols="2" class="p-0">
				<b-button block v-if="id"
                          id="admin-btn-cancel"
                          class="admin-button"
                          @click="deleteActivityDialog">
                    Удалить
                </b-button>
			</b-col>
			
		</b-row>

    </b-container>

</template>
<script>
import AllRoutes from '@/routes/all.routes'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'
import ApiHeaders from '@/store/models/ApiHeaders'

import ActivityEditModel from '@/store/models/admin/activities/ActivityEdit'
import Consts from '@/store/models/consts/adminConsts'

import CustomMultiselect from '@/components/shared/CustomMultiSelect'
import CustomColorMultiselect from '@/components/shared/CustomColorMultiSelect'
import YesNoInput from '@/components/shared/YesNoInput'

export default {
		computed: {
            header: function() {
	            return this.id == null 
							? "Создание активности аудита" 
							: "Редактирование активности аудита";
            },
			allBlocksNoReplay: function() {
				return this.allBlocks.filter(e => this.entity.BlockIds.every(b => b != e));
			}
        },
		data: function(){	
			let apiHeaders = new ApiHeaders().mapToDto(this.$route.query['api-Version']);

            let load = new Loading();
			let id = Object.keys(this.$route.query).length 
						? this.$route.query.id 
						: null;

			let entity = null;

			if(id)
				this.getDependentInfo(id, load, apiHeaders);
			else {
				entity = new ActivityEditModel().mapFromDto(null);
				this.getTags(load, apiHeaders);
				this.getBlocks(load, apiHeaders);
			}
       	
			return {
                entity: entity,
                id: id,
				load: load,
				apiHeaders: apiHeaders,

				auditTypes: Consts.AuditType,
				auditStatus: Consts.ActivityAuditStatus,

				allTags: [],				
				allBlocks: []
			};
		},
		methods: {
			getDependentInfo: function (id, load, apiHeaders) {
				load.Calculate(true);
				
				apiService.Admin.Activities.Get(id, apiHeaders)
					.then(response => {
						this.entity = new ActivityEditModel().mapFromDto(response.data);
						this.getTags(load, apiHeaders);
						this.getBlocks(load, apiHeaders);
						load.Calculate(false);
					})
					.catch(() => load.Calculate(false));
			},

			getTags: function(load, apiHeaders) {
				load.Calculate(true);

				apiService.Admin.Tags.Activities.GetAllInfo(apiHeaders)
					.then(response => {
						this.allTags = response.data.SubTags;

						if(this.id && this.entity.TagIds && this.entity.TagIds.length) {

							for (let i = 0; i < this.entity.TagIds.length; i++) {
								const tag = this.allTags.find(e => e.Id == this.entity.TagIds[i]);
								this.entity.TagIds[i] = tag;								
							}
						}

						load.Calculate(false);
					})
					.catch(() => load.Calculate(false));
			},

			getBlocks: function(load, apiHeaders) {
				load.Calculate(true);

				apiService.Admin.Blocks.GetAll(apiHeaders)
					.then(response => {
						this.allBlocks = response.data.map(function (e) { return {Id: e.Id, Text: e.Name} });

						if(this.id && this.entity.BlockIds && this.entity.BlockIds.length) {
							
							for (let i = 0; i < this.entity.BlockIds.length; i++) {
								const block = this.allBlocks.find(elem => elem.Id == this.entity.BlockIds[i]);
								this.entity.BlockIds[i] = block;								
							}
						}								

						load.Calculate(false);
					})
					.catch(() => load.Calculate(false));
			},

			saveActivity: function () {	
				let isInValid = this.entity.isInValid();
				
				if(isInValid) {
					if(isInValid == 1){				
						dialogService.showAlert('Предупреждение', 'Вы не заполнили обязательные поля. Поле "Выберите теги" не является обязательным.');
						return;
					}
					else if(isInValid == 2){
						dialogService.showAlert('Предупреждение', 'Должен быть добавлен хотя бы один блок вопросов.');
						return;
					}
				}			

				this.load.Calculate(true);

				let activity = this.entity.mapToDto();

                apiService.Admin.Activities.PostUpdate(activity, this.apiHeaders)
					.then(() => { this.$router.push({ path: AllRoutes.Admin.Activities.Index, query: { 'api-Version': this.apiHeaders['api-Version'] } })})
					.catch(() => this.load.Calculate(false));
			},

			deleteActivityDialog: function () {
				if (!this.$route.query.id)
					return;
				
				dialogService.showConfirm('Подтверждение удаления', 'Вы действительно хотите удалить данный тип активности?')
					.then(() => {					
						this.deleteActivity();																		
					})
					.catch(() => {});
			},

			deleteActivity: function() {
				this.load.Calculate(true);

                apiService.Admin.Activities.PostDelete(this.$route.query.id, this.apiHeaders)
					.then(() => {
						this.$router.push({ path: AllRoutes.Admin.Activities.Index, query: { 'api-Version': this.apiHeaders['api-Version'] } });
					})
					.catch(() => this.load.Calculate(false));
			},

			addBlock: function() {			
				this.entity.BlockIds.push(null);
			},

			deleteBlock: function(index) {				
				this.entity.BlockIds.splice(index, 1);
			},

			openBlock: function (item) {	
			let routeData = this.$router.resolve({ path: `/Admin/Blocks/Edit?id=${item.Id}`, query: { 'api-Version': this.apiHeaders['api-Version'] } });
			window.open(routeData.href, '_blank');
			}
        },
        components: {
			Spinner,
            CustomMultiselect,			
			CustomColorMultiselect,
			YesNoInput
		}
}
</script>